import { Component } from '@verndale/core';
import MicroModal from 'micromodal';

import { constEvent } from '../utils/constants';
import { dispatchGenericEvent } from '../utils/dispatch-events';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el,
      $btnQuickView: document._$$('.product-search-listing-card__quick-view'),
      $modalContainer: null
    };
    this.modalId = null;

    this.init();
  } //setupDefaults

  addListeners() {
    const { $btnQuickView } = this.dom;

    document?._on(
      constEvent.SHOW_QUICK_VIEW_MODAL,
      this.showQuickViewModalByDispatch.bind(this)
    );
    document?._on(
      constEvent.MODAL_QUICK_VIEW_CONTAINER_NO_IMAGES,
      this.addNoImagesClass.bind(this)
    );

    $btnQuickView?._on('click', this.loadQuickView.bind(this));
  } //addListeners

  init() {
    const { $el } = this.dom;

    this.dom.$modalContainer = $el.closest('.generic-modal__container');

    const $genericModal = $el.closest('.generic-modal');
    if ($genericModal) {
      this.modalId = $genericModal.getAttribute('id') || null;
    }
  } //init

  showModal() {
    if (this.modalId) {
      MicroModal.show(this.modalId, {
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
      });
    }
  } //showModal

  loadQuickView(e) {
    e?.stopImmediatePropagation();
    e?.preventDefault();

    const { $modalContainer } = this.dom;
    $modalContainer?.classList?.remove(
      constEvent.MODAL_QUICK_VIEW_CONTAINER_NO_IMAGES
    );

    this.showModal();

    const productId = e?.currentTarget?.getAttribute('data-product-id') || null;
    if (productId) dispatchGenericEvent(constEvent.LOAD_QUICK_VIEW, productId);
  } //loadQuickView

  showQuickViewModalByDispatch(e) {
    this.showModal();

    const productId = e?.detail || null;
    if (productId) dispatchGenericEvent(constEvent.LOAD_QUICK_VIEW, productId);
  } //showQuickViewModalByDispatch

  addNoImagesClass() {
    const { $modalContainer } = this.dom;

    $modalContainer?.classList?.add(
      constEvent.MODAL_QUICK_VIEW_CONTAINER_NO_IMAGES
    );
  } //addNoImagesClass
}

export default Module;
